import script from "./GroupBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupBar.vue?vue&type=script&setup=true&lang=js"

import "./GroupBar.vue?vue&type=style&index=0&id=1248aece&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1248aece"]])

export default __exports__